import type { FaireProductEntity } from "../../entity_types/product";

export const p_4xe6ydayss: FaireProductEntity = {
  token: "p_4xe6ydayss",
  type: "product",
  name: "Yellow Pickled Mango",
  brandName: "Snack Hawaii",
  imageUrl:
    "https://cdn.faire.com/fastly/43bb9054aeceaa547f7900c7aea2bf1adcce6f278b1db7881d744ffaaf7469b5.jpeg",
  priceDollars: 3.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6378d217c33bfea2e04065f75e81d39bc40034b9bd8e6b41219dc53c8dd18736.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
